import * as React from "react"

/**
 * A visually hidden polite live region that announces a copy confirmation.
 * The confirmation tooltip is not announced by screen readers, so a copy
 * control renders this beside itself. The region stays mounted and only its
 * text changes, which is what makes assistive tech read the update.
 */
export function CopyAnnouncement({ message }: { message: string | null }) {
  return (
    <span role="status" aria-live="polite" className="sr-only">
      {message ?? ""}
    </span>
  )
}
